import {createElement, Component, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';

export const EDIT = <FormattedMessage
  id="ui.label.button.forms.editable.EDIT"
  defaultMessage="Edit"
  description="A button for read-only data that enables editing, swapping text and elements with their appropriate inputs." />;

export const CANCEL = <FormattedMessage
  id="ui.label.button.forms.editable.CANCEL"
  defaultMessage="Cancel"
  description="A button for inline forms that reverts the user's current edits, bringing them to the read-only version of the data." />;

export const SAVE = <FormattedMessage
  id="ui.label.button.forms.editable.SAVE"
  defaultMessage="Save"
  description="A submit button for inline forms." />;

export const BACK = <FormattedMessage
  id="ui.label.button.forms.BACK"
  defaultMessage="Back"
  description="Like a 'Cancel' button for forms, but explicitly returns the user some previous view." />;

export const CREATE = <FormattedMessage
  id="ui.label.button.forms.CREATE"
  defaultMessage="Create"
  description="A generic 'Submit'-like button for forms, but specifically for forms that create new things (rather than update existing ones)." />;


export const DAY = <FormattedMessage
  id="ui.label.input.forms.DAY"
  defaultMessage="Day"
  description="The label for picking a day within a date picker." />;

export const MONTH = <FormattedMessage
  id="ui.label.input.forms.MONTH"
  defaultMessage="Month"
  description="The label for picking a month within a date picker." />;

export const YEAR = <FormattedMessage
  id="ui.label.input.forms.YEAR"
  defaultMessage="Year"
  description="The label for picking a year within a date picker." />;

export const TODAY = <FormattedMessage
  id="ui.label.button.forms.TODAY"
  defaultMessage="Today"
  description="Short button label for selecting today's date in a date input (for a form)." />;

export const NOW = <FormattedMessage
  id="ui.label.button.forms.NOW"
  defaultMessage="NOW"
  description="Short button label for selecting the current time in a date-and-time input (for a form)." />;

export const PLEASE_SELECT = <FormattedMessage
  id="ui.label.input.forms.PLEASE_SELECT"
  defaultMessage="Please select"
  description="A short prompt for either the unset state of drop downs or as an options heading inside select drop down selects." />;



// WEBPACK FOOTER //
// ./lib/rlink-forms/labels.jsx